export default "__VITE_PUBLIC_ASSET__75bf41ca__"